import { BusinessStreamPageType } from "../../types/optimizely/businessStreamPage";
import { OptimizelyExpandedValue } from "../../types/optimizely/expanded";

export const businessStreamPageTypeName = "BusinessStreamPage";

export const isBusinessStreamPage = (content: OptimizelyExpandedValue): content is BusinessStreamPageType => {
  return content.contentType.includes(businessStreamPageTypeName);
}